import { MetadatiRepertorioVO } from "./metadati-repertorioVO";

export class DecretoVO {
  oggetto: string;
  id: string;
  metadatiRepertorio: MetadatiRepertorioVO;
  dataConclusione: string;
}
